function fnProjectItemSlider(i, oSection) {
  const swiperEl = oSection.querySelector(".swiper");

  if (swiperEl && !swiperEl.swiper) {
    new Swiper(swiperEl, {
      effect: "creative",
      speed: 700,
      creativeEffect: {
        prev: {
          translate: ["0%", 0, 0],
        },
        next: {
          translate: ["100%", 0, 1],
        },
      },
      navigation: {
        prevEl: swiperEl.querySelector(".prev"),
        nextEl: swiperEl.querySelector(".next"),
      },
    });
  }
}
